module.exports = __webpack_public_path__ + "media/assets/icons/marker-e6a16a29097ad6a9169397a6846d87ce.svg";